export * as Tabs from './styled/tabs';
